import { render, staticRenderFns } from "./Export.vue?vue&type=template&id=4800ff8c&"
import script from "./Export.vue?vue&type=script&lang=js&"
export * from "./Export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports